import { Directive, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Directive({
  selector: 'ng-select[caiCloseOnScroll]',
  standalone: false,
})
export class NgSelectCloseOnScrollDirective implements OnInit, OnDestroy {
  private scrollListener: () => void;

  constructor(
    private ngSelect: NgSelectComponent,
    private elementRef: ElementRef,
  ) {}

  ngOnInit() {
    this.scrollListener = this.onScroll.bind(this);
    // Listen to scroll events on window and all parent elements
    window.addEventListener('scroll', this.scrollListener, true);
  }

  ngOnDestroy() {
    if (this.scrollListener) {
      window.removeEventListener('scroll', this.scrollListener, true);
    }
  }

  private onScroll(event: Event) {
    if (!this.ngSelect?.isOpen) {
      return;
    }

    const target = event.target as HTMLElement;
    if (!target) {
      return;
    }

    // Don't close if scrolling inside the ng-select element itself
    if (this.elementRef.nativeElement.contains(target)) {
      return;
    }

    // Don't close if scrolling inside the dropdown panel (which is appended to body)
    const dropdownPanel = target.closest('.ng-dropdown-panel');
    if (dropdownPanel) {
      return;
    }

    // Close the dropdown if scrolling anywhere else
    this.ngSelect.close();
  }
}
